import React from 'react';
import SupportEmail from '../../Common/Helpers/SupportEmail';
import { HTMLTrans, withTranslationProvider } from '../../Common/Translations';
import config from '../../../config';

const RenderInfo = (props) => {
  const {
    data = [],
    code,
    t
  } = props;

  if (Object.prototype.hasOwnProperty.call(data, code)) {
    return <div>
      <div className="pb-3"><HTMLTrans id="contact_us.contactinfo_find_us">Or find us at</HTMLTrans> </div>
      {data[code].add && <div className="d-flex align-items-start pb-3">
        <span dangerouslySetInnerHTML={{ __html: t(data[code].add.id, data[code].add.default) }}></span>
      </div>}
      <div className="d-flex align-items-start pb-3">
        <i className="fa fa-phone py-1"></i>
        <span className='pl-3' dangerouslySetInnerHTML={{ __html: t(data[code].tel.id, data[code].tel.default) }}></span>
      </div>
      <div className="d-flex align-items-start pb-3">
        <i className="fa fa-clock-o py-1"></i>
        <span className='pl-3' dangerouslySetInnerHTML={{ __html: t(data[code].info.id, data[code].info.default) }}></span>
      </div>
      <div className="pb-3"><i className="fa fa-envelope-o py-1"></i>
        <span className='text-primary pl-3'><SupportEmail/></span>
      </div>
      {data[code].whatsapp ? <div className="pb-3">
        <i className="fa fa-whatsapp py-1" style={{ color: '#25d366' }}></i>
        <span className="pl-3" dangerouslySetInnerHTML={{
          __html: `<a href=${t(data[code].whatsapp.id, data[code].whatsapp.default)} target="_blank">${t('contact_us.contactinfo_whatsapp', 'Chat with us on WhatsApp Web')}</a>`
        }} />
      </div> : config.storeCode !== 'PBTH' && <div className="d-flex align-items-start pb-3">
        <i className="fa fa-whatsapp py-1" style={{ color: '#25d366' }}></i>
        <a className='pl-3' href={t('contact_us.view_whatsapp_link', 'https://wa.me/60126485909?text=Hi')} target="_blank">
          <HTMLTrans id="contact_us.view_whatsapp_link_text">Chat with us on WhatsApp Web</HTMLTrans>
        </a>
      </div>  
      }
    </div>;
  }
  return (
    <div>
      <div className="pb-3"><HTMLTrans id="contact_us.contactinfo_email_us">Or email us at</HTMLTrans> </div>
      <i className="fa fa-envelope-o py-1"></i>
      <span className='text-primary pl-3'><SupportEmail/></span>
    </div>
  );
};

export default withTranslationProvider(RenderInfo);



// WEBPACK FOOTER //
// ./src/StaticPage/ContactUs/ContactInfo.js